import './BedroomPage.scss'
import {useEffect, useState} from "react";
import toilet from '../../sounds/toilet.mp3'
import nea from '../../sounds/nea.mp3'
import sleep from '../../sounds/sleep.mp3'
import {t} from "i18next";

const hrsSleepToHungry = {
  3: 10,
  6: 20,
  8: 30,
}

const hrsFatigue = {
  3: 30,
  6: 70,
  8: 100,
}

const workProgress = [
  "Brainstorm the idea on the topic",
  "Initiate the project",
  "Write code",
  "Write a lot of code",
  "A bit more coding",
  "Refactor code",
  "Fix bugs",
  "Looks good, but...",
  "Looks better",
  "Playable! ",
  "Awesome game",
]

const BedroomPage = (props) => {
  const {
    onChangeView,
    currentTime,
    onUpdateTime,
    setCurrentFatigue,
    currentFatigue,
    setCurrentHunger,
    currentHunger,
    foodPoisoning,
    setFoodPoisoning,
    soundsFX,
    soundsRef,
  } = props

  const [isShowBed, setIsShowBed ] = useState(false)
  const [notification, setNotification ] = useState("")

  useEffect(()=>{
    if (notification === '') return
    setTimeout(()=>{
      setNotification('')
    }, 3000)
  }, [notification])

  useEffect(()=>{
    if (foodPoisoning === false) return
    soundsFX.onPlay(toilet, false,false, soundsRef)
    setTimeout(()=>{
      setFoodPoisoning(false)
      onUpdateTime(3)
    }, 3000)
  }, [foodPoisoning])

  const onSleep = (hrs) => {
    setIsShowBed(false)
    if (currentFatigue === 0) {
      soundsFX.onPlay(nea, false,false, soundsRef)
      setNotification(`${t('bp-sleep-more')}`)
      return
    }
    if (currentHunger +  hrsSleepToHungry[hrs] > 100) {
      soundsFX.onPlay(nea, false,false, soundsRef)
      setNotification(`${t('bp-sleep-hungry')}`)
      return;
    }
    onUpdateTime(hrs)
    soundsFX.onPlay(sleep, false,false, soundsRef)
    setCurrentFatigue(prevState => prevState - hrsFatigue[hrs] < 0 ? 0 : prevState - hrsFatigue[hrs])
    setCurrentHunger(prevState => prevState + hrsSleepToHungry[hrs])
  }

  const dayNightSwitcher = ((currentTime >= 6 && currentTime < 12) || (currentTime >= 18 && currentTime < 23)) ? "06" :
    currentTime >= 12 && currentTime < 18 ? "12" : '00'


  return <div className="BedroomPage">

    <button className="bed" onClick={()=>{setIsShowBed(true)}} >
    </button>
    {!isShowBed ? <button className="bed" onClick={()=>{setIsShowBed(true)}} ></button>
    : <div className="bed-menu">
        <button className="bed-hr" onClick={()=>{onSleep(3)}} >
          {t('bp-sleep-3')} <span className="b-small">{t('bp-sleep-3ex')}</span>
        </button>
        <button className="bed-hr" onClick={()=>{onSleep(6)}} >
          {t('bp-sleep-6')} <span className="b-small">{t('bp-sleep-6ex')}</span>
        </button>
        <button className="bed-hr" onClick={()=>{onSleep(8)}} >
          {t('bp-sleep-8')} <span className="b-small">{t('bp-sleep-8ex')}</span>
        </button>
    </div>}
    <button className="kitchen" onClick={()=>{onChangeView("PCScreenPage")}} > </button>
    <button className="pc" onClick={()=>{onChangeView("PCScreenPage")}} > </button>
    <button className={"door " + (foodPoisoning ? "light" : "")} onClick={()=>{onChangeView("KitchenPage")}} >
      <div className="door-to-kitchen">
        {t('bp-toKitch')}
      </div></button>
    <div className={`window-${dayNightSwitcher}`}></div>
    {notification && <div className="notification">{notification}</div>}
  </div>
}

export default BedroomPage